import { combineReducers } from 'redux'

import cuisineTypeReducer from './cuisine-type-reducer'
import cuisineTypesReducer from './cuisine-types-reducer'

export default combineReducers({
  cuisineTypes: cuisineTypesReducer,
  cuisineType: cuisineTypeReducer,
})
